export const CONTRACT_ADDRESS = "0xc640B6C295A974D21896d0a75C07C45c021A7A4A";

